import React from 'react';
import { useSelector } from 'react-redux';
import { Fade } from '../../animation/animation';
import { RootState } from '../../store';
import CallTimeFeild from '../call-time-field/call-time-field';
import styles from './call-time-under-phone.module.scss';
import { CallTimeFormRegime } from '../../models/call-time-form-regime.model';

export default function CallTimeUnderPhone({regime}:{regime: CallTimeFormRegime}) {
	const { error } = useSelector((state:RootState) => state.main);
	const active = regime == 'straightUnderPhone' || !error;

	return (
		<section className={styles.default}>
			<Fade up delay={500} duration={500} when={active}>
				<h3 className={styles.header}>Укажите удобное для Вас время звонка</h3>
			</Fade>
			<Fade right when={active}>
				<CallTimeFeild/>
			</Fade>
		</section>
	)
}